import { msg } from '@lingui/core/macro'
import { createFileRoute } from '@tanstack/react-router'
import { FilesView } from '~/components/files/files-view'
import { decodeFilesSearch } from '~/components/files/files-view/search'
import { useProjectDetail } from '~/components/projects/project-detail'
import { titleFor } from '~/lib/route-title'

/** Open to leads too: briefing photos land here long before a contract. */
const ProjectFilesRoute = () => {
  const project = useProjectDetail()

  return <FilesView scope={{ kind: 'project', projectId: project._id }} />
}

export const Route = createFileRoute('/_authenticated/$workspaceSlug/projects/$projectId/files')({
  component: ProjectFilesRoute,
  head: () => ({ meta: [{ title: titleFor(msg`Files`) }] }),
  validateSearch: decodeFilesSearch,
})
